import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b41da29")

_pushScopeId("data-v-3b41da29")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Select Previous Registration")
const _hoisted_2 = { class: "body-container" }
const _hoisted_3 = { class: "buttons are-right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_readOnlyGrid = _resolveComponent("readOnlyGrid")
  const _component_modal_card = _resolveComponent("modal-card")

  return (_openBlock(), _createBlock(_component_modal_card, { active: _ctx.isVisible }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_readOnlyGrid, {
          gridItems: _ctx.prevRegistrations,
          gridColumns: _ctx.columns,
          isLoading: _ctx.isLoading,
          pageItemsOptions: [20, 40, 100],
          gridStyle: {maxHeight: '800px'},
          onRowClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.rowClicked($event)))
        }, null, 8, ["gridItems", "gridColumns", "isLoading"])
      ])
    ]),
    foot: _withId(() => [
      _createVNode("div", _hoisted_3, [
        _createVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeDialog()))
        }, "Close")
      ])
    ]),
    _: 1
  }, 8, ["active"]))
})